import react, { useMemo } from "react"

const informationalTextsPerTab = [
    {
        tab: `Select Columns`,
        text: `Optional screen for limiting the number of records to return in the report, selecting specific columns to include in ` +
            `the report, aliasing how columns should be named in the report, establishing the order ` + 
            `in which columns should be output in the report, and defining how columns should be translated and/or aggregated. If the ` +
            `screen is left blank, the report will include all records from all columns from all sources, and ` + 
            `all columns will be output with the database column name and in the order as they appear in the database by default.`,
    }, 
    {
        tab: 'Joins',
        text: `Optional screen for joining secondary sources. Utilize the “+ Column” button to join a source on multiple columns (example: joining algal results ` +
            `on ParentSampleID, EventNumber, and AliquotNumber).`
    }, 
    {
        tab: 'Where Clause',
        text: `Optional screen for filtering the records to include in the report. If no filters are added, the report will include all records from all data ` +
            `sources. The “AND” operator is used to combine multiple conditions, where all the conditions must be true for the record to be output in ` +
            `the report. The “OR” operator is used to combine multiple conditions, where at least one of the conditions must be true for the record to ` +
            `be output in the report. You can also specify how filters are executed through groups.`
    },
    {
        tab: 'Group By Columns',
        text: `Optional screen for selecting columns the report should be grouped by. If the screen is left blank, the report will not be grouped by any column by default. ` +
            `If an aggregated column is included in the Select Columns screen, you must group by all available columns.`  
    },
    {
        tab: 'Order By Columns',
        text: `Optional screen for selecting columns the report should be ordered by and how they should be sorted. If the screen is left blank, ` +
           `the report will not be ordered by any column by default.`  
    }
]

const InformationalTextSection = ({ title }) => {
    const selectedTabInfoObj = useMemo(() =>
        informationalTextsPerTab.find(x => x.tab === title)
    , [title])

    return (<> {
        selectedTabInfoObj && selectedTabInfoObj.text 
            && (<p style={{ margin: `1rem 3rem 1rem 1rem` }}>
                    <i>{selectedTabInfoObj.text}</i>
                </p>)
    }</>)
}

export default InformationalTextSection